import React from 'react';
import { Link } from 'react-router-dom';
import { FilmIcon } from 'lucide-react';
import { ProductionCard } from '../components/ProductionCard';
import { EmptyState } from '../components/EmptyState';
import { useCatalog } from '../contexts/CatalogContext';
import { buttonClass, pagePadding } from '../utils/styles';
import type { Category } from '../types/production';
interface CategoryPageProps {
  category: Category;
  title: string;
  description: string;
  emptyTitle: string;
}
export function CategoryPage({
  category,
  title,
  description,
  emptyTitle
}: CategoryPageProps) {
  const {
    published,
    upcoming
  } = useCatalog();
  const items = published.filter(p => p.category === category);
  const soon = upcoming.filter(p => p.category === category);
  return <div className={`pb-24 pt-28 md:pt-32 ${pagePadding}`} data-id="element-381" data-mp="31rga6ak0oo5r">
      <header className="max-w-2xl" data-id="element-382" data-mp="31szqg15oaz7j">
        <h1 className="font-display text-4xl font-black uppercase tracking-tight md:text-6xl" data-id="element-383" data-mp="36qjh60jk54gd">{title}</h1>
        <p className="mt-4 text-base text-mist md:text-lg" data-id="element-384" data-mp="3bby4390t8bzd">{description}</p>
      </header>

      {items.length === 0 && soon.length === 0 ? <EmptyState icon={FilmIcon} title={emptyTitle} description="Esta sección se llenará a medida que Nicole publique nuevas obras." action={<Link to="/" className={buttonClass('secondary', 'md')} data-id="element-386" data-mp="2xlumivcvl6g9">
              Volver al inicio
            </Link>} data-id="element-385" data-mp="36koicjidtssr" /> : <>
          {items.length > 0 && <ul className="mt-12 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-387" data-mp="3qaief9s4qu2s">
              {items.map(p => <li key={p.id} data-id="element-388" data-mp="3lc74z05qyll3">
                  <ProductionCard production={p} data-id="element-389" data-mp="3gc2kz05mr8q4" />
                </li>)}
            </ul>}
          {soon.length > 0 && <section aria-labelledby="proximamente" className="mt-16" data-id="element-390" data-mp="29t4cwssg2z95">
              <h2 id="proximamente" className="font-display text-xl font-bold" data-id="element-391" data-mp="24vcmk37g7l72">Próximamente</h2>
              <ul className="mt-6 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-392" data-mp="26ekzspiieh5j">
                {soon.map(p => <li key={p.id} data-id="element-393" data-mp="1xclirx7hvd2l">
                    <ProductionCard production={p} data-id="element-394" data-mp="1xdeiie81d2b8" />
                  </li>)}
              </ul>
            </section>}
        </>}
    </div>;
}